(() => {
  if (window.rocksCustomDesignInitialized) return;
  window.rocksCustomDesignInitialized = true;
  let previousOverflow;
  function open(dialog) {
    if (!dialog || dialog.open) return;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
    }, { once: true });
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-design-open]');
    if (trigger) { event.preventDefault(); open(document.getElementById(trigger.dataset.designOpen)); }
    const close = event.target.closest('[data-design-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.custom-design')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  function results() {
    document.querySelectorAll('.custom-design [data-design-result]').forEach(result => open(result.closest('dialog')));
  }
  results();
  document.addEventListener('shopify:section:load', results);
})();